export default __webpack_public_path__ + "static/media/img-scanlife-logo.0c5cfa7a.png";